export const regexPatterns = {
  email: /^(([a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))$/,
  phoneNumber: "^[0-9\-\(\)\.\/\+]{8,18}$",
  name: /^[^\d\p{Emoji}\p{Emoji_Component}]+$/u
}

// For more info about email pattern: https: // pdw.ex-parrot . com / Mail-RFC822-Address . html
